import React, { FC } from 'react'
import { Link, useLocation } from 'react-router-dom'
import ROUTES from '../utils/routes'
import { StyledNotLoggedIn } from '.'

type StateType = {
  backUrl?: string;
}

const NotLoggedIn: FC = () => {
  const { state }: { state: StateType } = useLocation()
  return (
    <StyledNotLoggedIn>
      <h1 className="italics">Oh no!</h1>
      <p className="message">
        You must be{' '}
        <Link to={{ pathname: ROUTES.user.login, state: { from: state?.backUrl } }}>logged in</Link>{' '}
        with your active subscription to view this page.
      </p>
      <p className="message italics">
        Not an active user? <a href={ROUTES.user.signup}>Join Social Curator</a>.
      </p>
      <p className="message">
        Questions? Please email <a href="mailto:help@socialcurator.com">help@socialcurator.com</a>
      </p>
    </StyledNotLoggedIn>
  )
}

export default NotLoggedIn
